"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABLET_ONLY = exports.SCREEN_WIDE = exports.SCREEN_SMALL_MAX = exports.SCREEN_MEDIUM_MAX = exports.SCREEN_MEDIUM = exports.SCREEN_LARGE_MAX = exports.SCREEN_LARGE = exports.MOBILE_ONLY = exports.MIN_TABLET = exports.MAX_TABLET = exports.DESKTOP_ONLY = void 0;
var SCREEN_SMALL_MAX = 767;
exports.SCREEN_SMALL_MAX = SCREEN_SMALL_MAX;
var SCREEN_MEDIUM = 768;
exports.SCREEN_MEDIUM = SCREEN_MEDIUM;
var SCREEN_MEDIUM_MAX = 1023;
exports.SCREEN_MEDIUM_MAX = SCREEN_MEDIUM_MAX;
var SCREEN_LARGE = 1024;
exports.SCREEN_LARGE = SCREEN_LARGE;
var SCREEN_LARGE_MAX = 1199;
exports.SCREEN_LARGE_MAX = SCREEN_LARGE_MAX;
var SCREEN_WIDE = 1200;
exports.SCREEN_WIDE = SCREEN_WIDE;
var MIN_TABLET = "@media all and (min-width: ".concat(SCREEN_MEDIUM, "px)");
exports.MIN_TABLET = MIN_TABLET;
var MAX_TABLET = "@media all and (max-width: ".concat(SCREEN_MEDIUM_MAX, "px)");
exports.MAX_TABLET = MAX_TABLET;
var MOBILE_ONLY = "@media all and (max-width: ".concat(SCREEN_SMALL_MAX, "px)");
exports.MOBILE_ONLY = MOBILE_ONLY;
var TABLET_ONLY = "@media all and (min-width: ".concat(SCREEN_MEDIUM, "px and max-width: ").concat(SCREEN_MEDIUM_MAX, "px)");
exports.TABLET_ONLY = TABLET_ONLY;
var DESKTOP_ONLY = "@media all and (min-width: ".concat(SCREEN_LARGE, "px)");
exports.DESKTOP_ONLY = DESKTOP_ONLY;